import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { AppSidebarComponent } from './app.sidebar.component';
import { LayoutService } from './service/app.layout.service';
import { StyleClassModule } from 'primeng/styleclass';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { StorageService } from '../_services/storage.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    AppSidebarComponent,
    StyleClassModule,
    ButtonModule,
    InputTextModule,
  ],
  templateUrl: './app.topbar.component.html',
  styleUrl: './app.topbar.component.scss',
})
export class AppTopbarComponent {
  layoutService = inject(LayoutService);
  storageService = inject(StorageService);
  el = inject(ElementRef);

  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;
  activeItem!: number;

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onSidebarButtonClick() {
    this.layoutService.showSidebar();
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }
}
